import { Avatar } from "modules/avatar";
import { styles } from "./styles";

interface ICompanyLogoProps {
  url: string;
}

export const CompanyLogo = ({ url }: ICompanyLogoProps) => (
  <Avatar sx={styles.root} pictureUrl={url} data-testid="company-logo" />
);
